var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArthera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9664_3192)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9664_3192",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: -1,
    width: 47,
    height: 49
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 23.5125C0.375 36.5297 10.6987 47.1201 23.3879 47.1201C36.0772 47.1201 46.4009 36.5297 46.4009 23.5125C46.4009 10.4953 36.0772 -0.09375 23.3879 -0.09375C10.6987 -0.09375 0.375 10.4953 0.375 23.5125Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9664_3192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3878 -23.7012L69.4124 23.5127L23.3878 70.7265L-22.6367 23.5127L23.3878 -23.7012Z",
    fill: "url(#paint0_linear_9664_3192)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9664_3192",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -31,
    y: -51,
    width: 257,
    height: 149
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M225.709 -50.4414H-30.6133V97.4656H225.709V-50.4414Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9664_3192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.3482 19.0927V32.8261H30.8359V19.0927C30.8359 17.0425 29.2098 15.3731 27.21 15.3731V10.7441C31.6969 10.7441 35.3482 14.4884 35.3482 19.0927Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9664_3192",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -31,
    y: -51,
    width: 257,
    height: 149
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M225.709 -50.4414H-30.6133V97.4656H225.709V-50.4414Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9664_3192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.566 20.1377V24.7666C17.5661 24.7666 15.9401 26.4347 15.9401 28.4862V32.8262H11.4277V28.4862C11.4277 23.8819 15.079 20.1377 19.566 20.1377Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_9664_3192",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -31,
    y: -51,
    width: 257,
    height: 149
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M225.709 -50.4414H-30.6133V97.4656H225.709V-50.4414Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_9664_3192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6442 15.3564H21.1318V32.8259H25.6442V15.3564Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9664_3192",
    x1: 6.64361,
    y1: 6.32641,
    x2: 41.2267,
    y2: 40.0384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1DC0CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8E15F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E20000"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9664_3192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white",
    transform: "translate(-3 -3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArthera);
export default __webpack_public_path__ + "static/media/arthera.6aeb4ba0d4de87bea3338adb914136f2.svg";
export { ForwardRef as ReactComponent };